export default function imageLoader({ src, width, quality }) {
  // Sanity CDN: adjust w/h/q params so Next.js generates proper responsive srcset
  // This bypasses Vercel Image Optimization while keeping responsive behavior
  if (src.includes('cdn.sanity.io')) {
    try {
      const url = new URL(src)
      const origW = parseInt(url.searchParams.get('w'), 10)
      const origH = parseInt(url.searchParams.get('h'), 10)
      url.searchParams.set('w', width)
      if (origW && origH) {
        url.searchParams.set('h', Math.round(origH * width / origW))
      }
      if (quality) {
        url.searchParams.set('q', quality)
      }
      return url.toString()
    } catch {
      return src
    }
  }
  // SVGs are vector — no raster optimization needed, but vary URL by width to satisfy Next.js
  if (src.endsWith('.svg')) {
    return `${src}?w=${width}`
  }
  // All other sources: use Next.js Image Optimization as before
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`
}
